import { motion } from "framer-motion";
import { MessageSquareText } from "lucide-react";
import { useT } from "../lib/i18n";

export default function FloatingBookButton({ onOpen }) {
  const { t } = useT();
  return (
    <motion.button
      onClick={onOpen}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.97 }}
      className="fixed right-4 md:right-6 z-40 bg-[color:var(--primary)] text-white flex items-center gap-2 px-3.5 py-2.5 border border-black/30 shadow-lg"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 6.5rem)" }}
      data-testid="floating-book-btn"
    >
      <MessageSquareText size={14} />
      <span className="font-bold uppercase tracking-[0.18em] text-[10px] md:text-[11px]">
        {t("floatingBook")}
      </span>
    </motion.button>
  );
}
